import { FiltersInterface } from "../../../../Global/Interfaces/GlobalInterfaces";
import { SortOrder } from "../../../../Global/Types/GlobalTypes";
import { GameType, RankingsType } from "../../Types/LoyaltyTypes";

export default class RankingsFilters implements FiltersInterface {
  public sortOrder?: SortOrder = null;
  public rankType?: RankingsType = null;
  public leaderboardIds?: string[] = null;
  public gameType?: GameType | null = null;
  public limit?: number | null = null;
  public page?: number | null = null;
  public groupId?: string | null = null;

  constructor(filters: any) {
    this.sortOrder = filters.sortOrder;
    this.rankType = filters.rankType;
    this.leaderboardIds = filters.leaderboardIds;
    this.limit = filters.limit;
    this.page = filters.page;

    // Only set gameType if rankType is GAME, otherwise log warning and skip
    if (filters.gameType) {
      if (filters.rankType === "GAME") {
        this.gameType = filters.gameType;
      } else {
        console.warn(
          `RankingsFilters: gameType "${filters.gameType}" ignored because rankType is "${filters.rankType}". ` +
          `gameType can only be used when rankType is "GAME".`
        );
      }
    }

    // Only set groupId if rankType is TEMPLATE, otherwise log warning and skip
    if (filters.groupId) {
      if (filters.rankType === "TEMPLATE") {
        this.groupId = filters.groupId;
      } else {
        console.warn(
          `RankingsFilters: groupId "${filters.groupId}" ignored because rankType is "${filters.rankType}". ` +
          `groupId can only be used when rankType is "TEMPLATE".`
        );
      }
    }
  }

  public constructFiltersUrl = (): string => {
    let url = "";

    if (this.sortOrder) {
      url += "&";
      url += `sort_order=${this.sortOrder}`;
    }
    if (this.rankType) {
      url += "&";
      url += `rank_type=${this.rankType}`;
    }
    if (this.leaderboardIds) {
      url += "&";
      url += `type_ids=${this.leaderboardIds.join(",")}`;
    }
    // Only include gameType in URL if rankType is GAME
    if (this.gameType && this.rankType === "GAME") {
      url += "&";
      url += `game_type=${this.gameType}`;
    }
    if (this.limit) {
      url += "&";
      url += `limit=${this.limit}`;
    }
    if (this.page) {
      url += "&";
      url += `page=${this.page}`;
    }
    // Only include groupId in URL if rankType is TEMPLATE
    if (this.groupId && this.rankType === "TEMPLATE") {
      url += "&";
      url += `group_id=${this.groupId}`;
    }

    return url;
  };
}
